import {
  GQBuildingSizeUnit,
  GQBuildingUtilityType,
} from '../generated/graphql';
import { BuildingCleanPowerStatus } from './BuildingUtils';

export const UNIT_NAMES: {
  [key in 'short' | 'long']: { [unit in GQBuildingSizeUnit]: string };
} = {
  long: {
    [GQBuildingSizeUnit.SquareFeet]: 'Square feet',
    [GQBuildingSizeUnit.SquareMeters]: 'Square meters',
  },
  short: {
    [GQBuildingSizeUnit.SquareFeet]: 'ft²',
    [GQBuildingSizeUnit.SquareMeters]: 'm²',
  },
} as const;

export const CLEAN_POWER_NAMES: {
  [cleanPowerStatus in BuildingCleanPowerStatus]: string;
} = {
  ['NoCleanPower']: 'No',
  ['PartialCleanPower']: 'Yes, covering partial power consumption',
  ['FullCleanPower']: 'Yes, covering all power consumption',
  ['Unknown']: 'I don’t know',
} as const;

export const PARTIAL_CLEAN_POWER_PERCENTAGE_DEFAULT = 50;

export const BUILDING_UTILITY_TYPE_NAMES: Record<
  GQBuildingUtilityType,
  string
> = {
  [GQBuildingUtilityType.ElectricityConsumption]: 'Electricity',
  [GQBuildingUtilityType.StationaryCombustion]: 'Heating & fuel',
  [GQBuildingUtilityType.Waste]: 'Waste',
  [GQBuildingUtilityType.Water]: 'Water',
  [GQBuildingUtilityType.Refrigerant]: 'Refrigerants',
} as const;

// Ordered in the order they should be displayed in the UI
export const ALL_BUILDING_UTILITY_TYPES = Object.keys(
  BUILDING_UTILITY_TYPE_NAMES
) as Array<GQBuildingUtilityType>;
